<ion-header class="ion-no-border" [translucent]="true">
  <ion-toolbar>
    <ion-buttons slot="start" class="navbar-back">
      <ion-button (click)="close()">
        <ion-icon name="chevron-back-outline"></ion-icon> Zurück
      </ion-button>
    </ion-buttons>
    <ion-title class="ion-text-center navbar-title">Größe und Anzahl</ion-title>
  </ion-toolbar>
</ion-header>


<ion-content>
  <ion-list class="product-list">
    <ion-item-group *ngFor="let prod of product; trackBy: trackByModelId" class="product-group">

      <ion-item
        button
        detail="false"
        (click)="toggleSection(prod.productId)"
        class="color-header"
        [class.has-qty]="totalQty(prod) > 0"
        [class.last-opened]="lastOpenedId === prod.productId"
      >
        <div class="color-dot-wrap" slot="start">
          <img *ngIf="prod.colorcard && !prod['_imgErr']"
               [src]="proxyUrl(prod.colorcard)"
               class="color-dot"
               (error)="prod['_imgErr'] = true" />
          <span *ngIf="!prod.colorcard || prod['_imgErr']"
                class="color-dot"
                [style.background]="colorHex(prod)">
          </span>
        </div>

        <ion-label>
          <div class="color-name">{{ (prod.colorname || prod.color).toUpperCase() }}</div>
          <div class="color-code" *ngIf="prod.colorCode">Code: {{ prod.colorCode }}</div>
          <div class="color-name-de" *ngIf="showTranslations && prod.colorDe">{{ prod.colorDe.toUpperCase() }}</div>
          <app-karma-unavailable-badge
            *ngIf="prod.karmaUnavailable"
            [unavailable]="true"
            [since]="prod.karmaUnavailableSince"
            [model]="prod.model"
            [colorname]="prod.colorname || prod.color"
            [currentInfo]="prod.info"
            [orderId]="currentOrderId"
            (infoUpdated)="onKarmaInfoUpdated(prod, $event)">
          </app-karma-unavailable-badge>
          <span class="vorhanden-chip" *ngIf="sizesWithQty(prod).length">Im Auftrag</span>
        </ion-label>

        <div slot="end" class="header-end">
          <span *ngIf="totalQty(prod) > 0" class="qty-badge">{{ totalQty(prod) }}</span>
          <ion-icon
            [name]="expandedSections.has(prod.productId) ? 'chevron-up-outline' : 'chevron-down-outline'"
            class="chevron-icon"
          ></ion-icon>
        </div>
      </ion-item>

      <div
        class="size-list"
        *ngIf="expandedSections.has(prod.productId)"
        [class.last-opened]="lastOpenedId === prod.productId"
      >
        <div *ngFor="let size of prod.sizes; trackBy: trackBySize" class="size-row">
          <span class="size-label">{{ size.size }}</span>

          <div class="qty-control">
            <button class="qty-btn" (click)="decrementQuantity(size)">
              <ion-icon name="remove-outline"></ion-icon>
            </button>

            <ion-input
              class="qty-input"
              type="number"
              inputmode="numeric"
              [(ngModel)]="size.quantity"
              (ionChange)="updateQuantity(size, $event.target.value)"
              [value]="size.quantity ?? 0"
              placeholder="0"
              min="0"
            ></ion-input>

            <button class="qty-btn" (click)="incrementQuantity(size)">
              <ion-icon name="add-outline"></ion-icon>
            </button>
          </div>
        </div>
      </div>

    </ion-item-group>
  </ion-list>
</ion-content>

<ion-footer class="ion-no-border">
  <ion-toolbar>
    <ion-button expand="block" (click)="save()" class="save-btn">Speichern</ion-button>
  </ion-toolbar>
</ion-footer>
